export default __webpack_public_path__ + "static/media/welcome_bg_bubble.a711296e.png";